<template>
  <div class="footer">
    <b-container fluid id="footer">
      <b-row class="text-center justify-content-around footer-row">
        <b-col md="6" lg="4">
          <h4>Contact Us</h4>
          <hr />
          <p>Our sales our service department</p>
          <p>customerservice@dickquistautos.com</p>
          <p class="phone">(315) 216-4579</p>
          <b-row>
            <b-col class="days">
              <p>Monday</p>
              <p>Tuesday</p>
              <p>Wednesday</p>
              <p>Thursday</p>
              <p>Friday</p>
              <p>Saturday</p>
              <p>Sunday</p>
            </b-col>
            <b-col class="times">
              <p>9:00am - 6:00pm</p>
              <p>9:00am - 6:00pm</p>
              <p>9:00am - 6:00pm</p>
              <p>9:00am - 6:00pm</p>
              <p>9:00am - 6:00pm</p>
              <p>10:00am - 2:00pm</p>
              <p>By Appointment</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" class="map" align-self="center">
          <GmapMap
            :center="{ lat: 43.4636479, lng: -76.4605619 }"
            :zoom="18"
            style="width: auto; height: 300px;"
          >
            <!-- <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center = m.position"
            /> -->
          </GmapMap>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { gmapApi } from "vue2-google-maps";
  export default {
    data() {
      return {};
    },
    computed: {
      google: gmapApi,
    },
  };
</script>

<style lang="scss">
  @import "../assets/scss/components/footer/footer.scss";
</style>
